import React from 'react';
import {ButtonImportCustomersToProject} from "../components/ButtonImportCustomersToProject/ButtonImportCustomersToProject";

export function ImportCustomersForProjectColumnFormatter(cellContent) {

  return <ButtonImportCustomersToProject projectId={cellContent}/>
}